export default __webpack_public_path__ + "static/media/channel3.f698dd9f.svg";